import { roundToDecimals } from "../../../../lib/money";

export type DifferenceTone = "positive" | "negative" | "neutral";

/**
 * Difference in Amount Paid: today minus at-submit. Positive means the dealer
 * is now paid more than expected at submit.
 * @param {number} amountPaidToday - Amount Paid to Dealer Today.
 * @param {number} amountPaidAtSubmit - Amount Paid to Dealer at submit.
 * @returns {number} The difference (can be negative).
 */
export function calculateDifferenceInAmountPaid(amountPaidToday: number, amountPaidAtSubmit: number): number {
  return roundToDecimals(amountPaidToday - amountPaidAtSubmit);
}

/**
 * Colour semantics for the difference: green above, red below.
 * @param {number} difference - See calculateDifferenceInAmountPaid.
 * @returns {DifferenceTone} The tone.
 */
export function getDifferenceTone(difference: number): DifferenceTone {
  if (difference > 0) {
    return "positive";
  }
  return difference < 0 ? "negative" : "neutral";
}
